import Markdown from "markdown-to-jsx";
import { ReactNode, useEffect, useState } from "react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../../../components/ui/tooltip";
import "./markdown.css";
import { useWindowSize } from "usehooks-ts";

interface LinkProps {
  href: string;
  children: ReactNode;
}

const LinkComponent: React.FC<LinkProps> = ({ children, href }) => {
  const { width = 0 } = useWindowSize();

  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <a
            className="font-semibold truncate transition-all text-sky-600 w-fit hover:underline"
            href={href}
            target="_blank"
            rel="noreferrer"
          >
            {children}
          </a>
        </TooltipTrigger>
        <TooltipContent align="end">
          <div
            className={`max-w-[${width}px] overflow-hidden text-ellipsis`}
            style={{
              maxWidth: width - 10,
            }}
          >
            {href}
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

interface Props {
  markdownText: string;
  loading?: boolean;
}

const MarkdownStream = (props: Props) => {
  const [blink, setBlink] = useState(false);

  useEffect(() => {
    if (props.loading) {
      const timer = setTimeout(() => {
        setBlink(!blink);
      }, 500); // Set the blinking interval, e.g., 500ms

      return () => {
        clearTimeout(timer);
      };
    }
  }, [props.loading, blink]);

  const indicator = blink ? " ▍" : "";
  const text = props.markdownText + (props.loading ? indicator : "");

  return (
    <>
      <Markdown
        className="overflow-x-hidden markdown-body"
        options={{
          overrides: {
            a: {
              component: LinkComponent,
            },
          },
        }}
      >
        {text}
      </Markdown>
    </>
  );
};

export default MarkdownStream;
